import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { StudentRegistration } from 'src/app/models/student-registration';
import { RegistrationsService } from 'src/app/services/registrations/registrations.service';
import { accessMailMessage } from 'src/app/services/students/students.service';

import { CommonModule } from '@angular/common'; // für *ngIf, *ngFor, Pipes wie date
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormsModule } from '@angular/forms';
import { GenderPipe } from '../../../pipes/gender.pipe';
import { AddressPipe } from '../../../pipes/address.pipe';

@Component({
  selector: 'li-registration-list',
  templateUrl: './registration-list.component.html',
  styleUrls: ['./registration-list.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatTableModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    GenderPipe,
    AddressPipe
  ]
})
export class RegistrationListComponent implements OnInit {
  public loading: boolean = true;
  public registrations: StudentRegistration[] = new Array<StudentRegistration>();
  public dataSource = new MatTableDataSource<StudentRegistration>();

  public constructor(
    private registrationsService: RegistrationsService
  ) { }

  public ngOnInit() {
    this.dataSource.filterPredicate = function (record: any, filter: any) {
      if (filter.length < 3) {
        return true;
      }

      const searchIn =
        record.firstname?.toLocaleLowerCase() +
        record.lastname?.toLocaleLowerCase() +
        record.street?.toLocaleLowerCase() +
        record.email?.toLocaleLowerCase() || '';
      const searchFor = filter.toLocaleLowerCase() || '';

      return searchIn.indexOf(searchFor) >= 0;
    };

    this.getData();
  }

  public applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  public delete(registration: StudentRegistration): void {
    this.registrationsService.del(registration).subscribe(_ => this.getData());
  }

  public import(registration: StudentRegistration): void {
    this.registrationsService.import(registration).subscribe(response => {
      // The access mail is sent automatically on import; only report problems.
      if (response.accessMail === 'no-email' || response.accessMail === 'failed') {
        alert(accessMailMessage(response.accessMail, registration.email));
      }
      this.getData();
    });
  }

  private getData() {
    this.registrationsService.get().subscribe({
      next: registrations => {
        this.loading = false;
        this.registrations = registrations;
        this.dataSource.data = this.registrations;
      },
    });
  }
}
